import * as React from 'react';
import scansReducer from './scansReducer.js';
import { ScansContext } from './scansContext.js';

function ScansProvider({ children }) {
  
  const [state, dispatch] = React.useReducer(scansReducer, {
    scanFiles: [],
  });

  const value = [state, dispatch];

  return (
    <ScansContext.Provider value={value}>
      { children }
    </ScansContext.Provider>
  )
}

export default ScansProvider;

